
<div>
  <fieldset>
    <legend class="sr-only">What is the max distance you'll travel for a job?</legend>
    <Dropdown
      id="max-distance"
      ref="maxDistanceDropdown"
      v-model="distanceWillingToTravel"
      labelName="# of miles"
      :options="options"
      :status="status"
      :helperText="helperText"
      :required="true"
    />
  </fieldset>

  <div v-if="showMap" class="active-jobs-map mt-8">
    <gmap-map
      :center="{ lat: geoPoint.y, lng: geoPoint.x }"
      :zoom="map.zoom"
      :map-type-id="map.mapTypeId"
      :options="map.mapOptions"
    >
      <gmap-circle
        :center="{ lat: geoPoint.y, lng: geoPoint.x }"
        :radius="map.radius"
        :draggable="map.circleDraggable"
        :editable="map.circleEditable"
        :options="map.circleOptions"
      />
    </gmap-map>
    <Card customClasses="jobs-card max-w-232 mx-auto w-full" :elevation="3">
      <div v-if="jobsCountLoading" class="flex gap-8 m-16">
        <Spinner />
        <p class="text-body">Calculating active jobs near you</p>
      </div>
      <div v-else class="flex gap-8">
        <PlaceIcon :width="32" :height="32" color="#FF0064" class="mt-4" aria-hidden="true" />
        <div>
          <p class="text-h2" aria-hidden="true">{{ totalJobsCount }}</p>
          <p class="text-body" aria-hidden="true">active jobs near you</p>
          <span class="sr-only">{{ totalJobsCount }} active jobs near you</span>
          <p class="text-overline text-primary">{{ newJobsCount }} new today</p>
        </div>
      </div>
    </Card>
  </div>
</div>
